/**
 * Active-state matchers for the identity (Unified Profile) editor.
 *
 * The editor lives at `/{workspaceId}/identity/{id}` and shares no path prefix
 * with the "Cards" or "Team Templates" nav links, so those links can't rely on
 * the default href-prefix match. Instead they mark themselves active here.
 *
 * Templates open with `?type=template` (the editor page keys template mode on
 * that same param); cards — team, personal, or a member's — carry no `type`.
 */

type ActiveContext = {
  pathname: string;
  searchParams: { get(name: string): string | null };
};

function inIdentityEditor(workspaceId: string, pathname: string): boolean {
  return pathname.startsWith(`/${workspaceId}/identity/`);
}

/** Active while editing a template in the identity editor. */
export function isEditingTemplate(workspaceId: string) {
  return ({ pathname, searchParams }: ActiveContext): boolean =>
    inIdentityEditor(workspaceId, pathname) && searchParams.get('type') === 'template';
}

/** Active while editing a card (not a template) in the identity editor. */
export function isEditingCard(workspaceId: string) {
  return ({ pathname, searchParams }: ActiveContext): boolean =>
    inIdentityEditor(workspaceId, pathname) && searchParams.get('type') !== 'template';
}
